export const emptyProductPresentation = () => ({
    version: 1,
    days: null,
    nights: null,
    departureCity: '',
    accommodation: '',
    groupLabel: '',
    highlights: [],
    introduction: [],
});
export function isProductImageUrl(value) {
    return (typeof value === 'string' &&
        value.length <= 2048 &&
        (/^\/api\/customer\/public\/m2\/media\/[0-9a-f-]{36}\/content$/iu.test(value) ||
            /^https:\/\/[a-z0-9.-]+(?::\d{1,5})?\/[^\s<>]*$/iu.test(value)));
}
export function parseProductPresentation(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value))
        throw new Error('线路展示配置格式错误');
    const data = value;
    if (data.version !== 1)
        throw new Error('线路展示配置版本不支持');
    const text = (input, label, max) => {
        if (typeof input !== 'string' || input.length > max)
            throw new Error(`${label}最多 ${max} 字`);
        return input.trim();
    };
    const integer = (input, label, min) => {
        if (input == null)
            return null;
        if (typeof input !== 'number' || !Number.isInteger(input) || input < min || input > 365)
            throw new Error(`${label}须为 ${min}–365 的整数`);
        return input;
    };
    const days = integer(data.days, '行程天数', 1), nights = integer(data.nights, '住宿晚数', 0);
    if (nights !== null && (days === null || nights >= days))
        throw new Error('住宿晚数须小于行程天数');
    if (!Array.isArray(data.highlights) || data.highlights.length > 8)
        throw new Error('线路亮点最多 8 项');
    if (!Array.isArray(data.introduction) || data.introduction.length > 40)
        throw new Error('线路介绍最多 40 个内容块');
    const ids = new Set();
    const introduction = data.introduction.map((item) => {
        if (!item || typeof item !== 'object' || Array.isArray(item))
            throw new Error('图文内容格式错误');
        const block = item;
        const id = text(block.id, '内容标识', 100);
        if (!id || ids.has(id))
            throw new Error('图文内容标识重复或缺失');
        ids.add(id);
        if (block.type === 'heading' || block.type === 'paragraph') {
            const content = text(block.text, '介绍内容', block.type === 'heading' ? 100 : 4000);
            if (!content)
                throw new Error('请填写介绍内容或删除空白内容块');
            return { id, type: block.type, text: content };
        }
        if (block.type !== 'image' || !isProductImageUrl(block.url))
            throw new Error('请选择已上传图片或有效的 HTTPS 图片');
        return {
            id,
            type: 'image',
            url: block.url,
            caption: text(block.caption ?? '', '图片说明', 120),
        };
    });
    return {
        version: 1,
        days,
        nights,
        departureCity: text(data.departureCity ?? '', '出发城市', 40),
        accommodation: text(data.accommodation ?? '', '住宿标准', 60),
        groupLabel: text(data.groupLabel ?? '', '成团方式', 30),
        highlights: [...new Set(data.highlights.map((v) => text(v, '线路亮点', 24)).filter(Boolean))],
        introduction,
    };
}
//# sourceMappingURL=product-presentation.js.map